import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { NDfModuleLoqate } from './df-module-loqate.config';

export const providers = (options?: Partial<NDfModuleLoqate.IModuleOptions>) => [
    {
        provide: NDfModuleLoqate.OPTIONS,
        useFactory: () => {
            const config = typeof window !== 'undefined' ? window.dfConfig.loqate : undefined;
            return {
                ...(config || {}),
                ...defaultsDeep(options || {}, NDfModuleLoqate.DEFAULT_OPTIONS)
            };
        }
    }
];

/**
 * @usage Angular 18+
 * ```ts
 * providers: [
 *    provideDfModuleLoqate()
 * ]
 * ```
 */
export function provideDfModuleLoqate(options?: Partial<NDfModuleLoqate.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders(providers(options));
}
